import Layout from './components/Layout/Layout';

import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';

function App() {

  return (

    <Layout>

      <Hero />

      <About />

      <Experience />

      <Portfolio />

      <Contact />

    </Layout>

  );

}

export default App;